import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { explainPaperStyle, explainExampleTitleStyle, explainPaperTitleStyle, explainPaperTextStyle, explainExamplePaperStyle, explainExampleTextStyle, explainExampleImageBoxStyle} from '../../../../../styles/commonStyles';

// 연수 메타데이터
export interface TrainingMetadata {
  id: string;
  title: string;
  category: string;
  description: string;
  instructor: string;
  duration: string;
  date: string;
  tags: string[];
  materials: string[];
  status: 'active' | 'completed' | 'upcoming';
  path: string;
}

export const trainingMetadata: TrainingMetadata = {
  id: '1',
  title: 'MakeCode Arcade 게임 개발 연수',
  category: 'makecodearcade',
  description: 'MakeCode Arcade를 활용한 게임 개발 기초부터 고급까지 학습하는 연수입니다.',
  instructor: '김게임',
  duration: '4시간',
  date: '2024-01-20',
  tags: ['MakeCode', '게임개발', '기초'],
  materials: ['MakeCodeArcadeTraining.tsx', '게임개발가이드.pdf'],
  status: 'completed',
  path: '/teacher-training/completed/MakeCodeArcadeTraining'
};

const MakeCodeArcadeTraining: React.FC = () => {
  const navigate = useNavigate();
  const exampleRef = useRef<HTMLDivElement>(null);
  const practiceRef = useRef<HTMLDivElement>(null);
  const [isPdfExpanded, setIsPdfExpanded] = useState(false);

  return (
    <div style={{ 
      width: '100%', 
      minHeight: '100%', 
      boxSizing: 'border-box', 
      padding: '24px', 
      margin: 0, 
      display: 'flex', 
      flexDirection: 'column',
      overflow: 'auto'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '24px' }}>
        <button
          onClick={() => navigate('/teacher-training/training-pages')}
          style={{
            marginRight: '16px',
            padding: '8px 16px',
            backgroundColor: '#1976d2',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          ← 돌아가기
        </button>
        <h1 style={{ fontSize: '2rem', fontWeight: 'bold', margin: 0 }}>
          MakeCode Arcade 게임 개발 연수
        </h1>
      </div>
      <div style={{ 
        marginBottom: '24px', 
        border: '1px solid #ccc', 
        padding: '16px', 
        borderRadius: '8px', 
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        backgroundColor: 'white'
      }}>
        <h2 style={{ fontWeight: 'bold', marginBottom: '16px', fontSize: '1.25rem' }}>
          📚 목차
        </h2>
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          <li style={{marginBottom: '8px'}}>
            <a href="#기술-교과에서의-성취기준" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              기술 교과에서의 성취기준
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#평가-계획" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              평가 계획
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#평가-진행-시-고려할-사항들" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              평가 진행 시 고려할 사항들
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#프로젝트-설명" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              프로젝트 설명(2025년 7월 서울 기술교사 자율 연수)
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#사용-도구-설명" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              사용 도구 설명
            </a>
          </li>
          <li style={{marginBottom: '8px'}}>
            <a href="#참고" style ={{textDecoration: 'none', color: '#1976d2', fontWeight: 500}}>
              참고
            </a>
          </li>
        </ul>
      </div>
      {/* 프로젝트 소개 */}
      <div style={{ display: 'flex', alignItems: 'end', marginBottom: '24px', gap: '16px' }}>
        <p style={{ color: '#666', margin: 0, fontSize: '1rem', lineHeight: '1.6' }}>
          본 프로젝트는 2025년 선린중학교 기술교과에서 진행된 프로젝트로, 당시 염창중학교 김치완선생님과 공동으로 진행한 프로젝트입니다.<br/>
          정보통신기술에서의 기술적 문제 해결을 게임이라는 형태의 표현 방식을 빌려 진행한 프로젝트입니다.<br/>
        </p>
      </div>
      {/* 성취기준 설명 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="기술 교과에서의 성취기준">
        기술 교과에서의 성취기준
      </h2>
      <p style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
      2025 개정 교육과정 기술 교과에서의 성취기준은 다음과 같습니다.<br/>
      <ul>
        <li>
          <b>9기가 04-05: 정보통신과 인공지능 기술의 활용 사례를 탐구하고, 정보통신과 인공지능 기술이 우리 삶에 미치는 영향을 다양한 관점에서 평가한다.</b>
        </li>
        <li>
          <b>9기가 04-05: 정보통신과 인공지능 기술 관련 문제를 이해하고 해결 방안을 탐색, 실현, 평가함으로써 긍정적인 문제 해결 태도를 갖는다.</b>
        </li>
      </ul>
      </p>
      {/* 평가 계획 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="평가-계획">
        평가 계획
      </h2>
      {/* 평가 계획 설명 */}
      <p style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        본 평가 계획은 기술적 문제를 게임이라는 표현 방식으로 어떻게 해결할건지에 대한 것에 초점을 두고 있습니다.<br/>
        개별 활동에 대한 평가와 모둠 활동에 대한 평가가 섞여있으며, 모둠 활동에 대한 평가의 비중이 훨씬 높습니다.<br/>
        평가 계획은 다음과 같습니다.<br/>
      </p>
      
      {/* PDF 토글 버튼 */}
      <div style={{ marginBottom: '16px', textAlign: 'center' }}>
        <button
          onClick={() => setIsPdfExpanded(!isPdfExpanded)}
          style={{
            padding: '12px 24px',
            backgroundColor: isPdfExpanded ? '#f44336' : '#4CAF50',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '1rem',
            fontWeight: '600',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            margin: '0 auto',
            transition: 'all 0.3s ease'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = 'none';
          }}
        >
          {isPdfExpanded ? '📄 PDF 닫기' : '📄 PDF 열기'}
        </button>
      </div>
      
      {isPdfExpanded && (
        <div style={{ 
          width: '100%', 
          height: '1400px', 
          border: '1px solid #ddd', 
          borderRadius: '8px',
          marginBottom: '24px'
        }}>
          <iframe 
            src="/pdfs/게임스타트업프로젝트 평가계획.pdf"
            width="100%" 
            height="100%"
            style={{ border: 'none' }}
            title="게임스타트업프로젝트 평가계획"
          />
        </div>
      )}
      {/* 평가에서의 고민점*/}      
      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="평가-진행-시-고려할-사항들">
        평가 진행 시 고려할 사항들
      </h2>
      <p style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        위의 평가계획은 예시일 뿐, 완벽하지 않습니다. 따라서, 수정하셔서 사용하시는 경우 아래 사항들을 고려해주세요.<br/>
        <ul>
          <li>
            개별 활동, 모둠 활동에 대한 과정을 어떻게 평가할 것인가?
          </li>
          <li>
            참여하지 않는 학생에 대해서는 어떻게 평가 점수를 부여할 것인가?
          </li>
          <li>
            모둠 활동에 대한 평가 시 모둠 내에서 개별 활동에 대한 평가를 어떻게 할 것인가?
          </li>
          <li>
            생성형 AI를 사용하여 게임을 기획, 설계하는 경우 이를 어떻게 평가요소에 반영할 것인가?
          </li>
          <li>
            <b>AI를 활용하여 게임을 제작하는 경우(바이브코딩 등) 이를 어떻게 평가요소에 반영할 것인가?</b><br/>
            AI를 활용하여 게임을 제작하는 학생들이 간혹 있습니다. 대부분 블록 코딩 방식으로 진행하겠지만, AI를 활용하는 경우 Javascript나 python 코드를 제시하기에 이를 복사해서 사용하게 됩니다.<br/>
            이 과정에서 학생들은 설계한 내용을 게임으로 제작하는데 있어 생각보다 많은 시행착오를 겪으며, 교사의 지도하에 진행될 수 있도록 고려하신다면 학생들에게 좋은 경험이라고 생각합니다.<br/>
            다만, 이를 어떻게 평가로 반영할 것인지에 대한 고민은 필요합니다.<br/>
          </li>
          <li>
            <b>프로그래밍 평가에 대한 요소에 너무 집중하지 않는가?(프로그래밍을 통해 문제를 해결하는거에 주안점을 두고 있지는 않은가?)</b><br/>
            게임을 제작하는 활동에서 프로그래밍에 대한 평가의 비중이 높아지는 경우, 프로그래밍 능력, 컴퓨팅 사고력 등에 평가 초점이 맞춰질 수 있습니다.<br/>
            참고로 아래는 정보교과에서의 2025 성취기준입니다.<br/>
            <ul>
              <li>
                [9정03-09] 다양한 학문 분야의 문제 해결을 위해 협력하여 소프트웨어를 개발한다.<br/>
              </li>
              <li>
                [9정03-10] 실생활의 문제를 탐색하여 발견하고, 프로그래밍을 통해 해결한다.<br/>
              </li>
            </ul>
            프로그래밍에 대한 역량은 정보교과에서 충분히 다루고 있다고 생각하며, 기술교과에서 이를 중점으로 평가를 진행하는 것에 필자는 부정적인 입장입니다.<br/>
            이에 정보교과와의 융합수업이 아닌 이상, 이 프로젝트를 진행하면서 완벽한 게임을 제작하는 것을 목표로 하여 프로그래밍에 대한 평가에 주안점을 두기 보다는 기술적 문제 해결 능력을 중점으로 다루고자 하는 기술적 문제에 대한 해결책을 게임이라는 형태로 녹여 얼마나 잘 담아 냈는가를 중점으로 평가하는 것을 권장드립니다.<br/>
            본 프로젝트도 이를 고려하여, 단순히 게임을 제작하는 것이 아닌 문제를 찾고 이를 게임에 담아 표현하는 과정에서 게임의 제품화, 유통, 유저와의 공유 등을 고려하게 하고 있습니다. 학생들에게도 왜 게임이라는 형태로 기술적 문제를 해결하고자 하는지에 대한 설명이 필요합니다.
          </li>
        </ul>
      </p>
      {/* 프로젝트 설명, Canva */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="프로젝트-설명">
        프로젝트 설명(2025년 7월 서울 기술교사 자율 연수)
      </h2>
      <div style={{ position: 'relative', width: '100%', height: 0, paddingTop: '56.25%', paddingBottom: 0, boxShadow: '0 2px 8px 0 rgba(63,69,81,0.16)', marginTop: '1.6em', marginBottom: '0.9em', overflow: 'hidden', borderRadius: '8px', willChange: 'transform' }}>
        <iframe loading="lazy" style={{ position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, border: 'none', padding: 0, margin: 0 }}
          src="https://www.canva.com/design/DAGuoXQU1i0/Nn-eaU8_WY97d80veWorig/view?embed" allowFullScreen={true} allow="fullscreen">
        </iframe>
      </div>
      {/* 사용 도구 설명 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="사용-도구-설명">
        사용 도구 설명
      </h2>
      <p style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        본 프로젝트에서 사용한 도구는 다음과 같습니다.
        <ul>
          <li>
            <b><a href="https://www.microsoft.com/ko-kr/microsoft-teams/group-chat-software" target="_blank" rel="noopener">Microsoft Teams</a>: 과제 제시 및 수합, 개별 역량 평가, 모둠 활동 설계 진행 등(학교 여건에 맞게 대체 가능)</b>
          </li>
          <li>
            <b><a href="https://arcade.makecode.com/" target="_blank" rel="noopener">Makecode Arcade</a>: 게임 제작 도구</b>
          </li>
          <li>
            <b><a href="https://www.canva.com/" target="_blank" rel="noopener">Canva</a>: 프로젝트 오픈 포트폴리오 제작 및 공유</b>
          </li>
          <li>
            <b><a href="https://maruedu.kr/makecodearcade" target="_blank" rel="noopener">Makecode Arcade 포털</a>: 제작한 게임과 포트폴리오 공유 및 피드백 진행(로그인 필요), 이미지 변환기 등 게임 제작에 필요한 도구 제공</b><br/>
            본 페이지에 대한 설명은 <a href="https://maruedu.kr/makecodearcade/info">링크</a>를 참고해주세요. padlet 등으로 대체도 가능합니다.
          </li>
        </ul>
      </p>
      {/* 참고 */}
      <h2 style={{ fontWeight: 'bold', marginBottom: '8px', fontSize: '1.5rem' }} id="참고">
        참고
      </h2>
      <p style={{ color: '#666', marginBottom: '16px', fontSize: '1rem', lineHeight: '1.6' }}>
        Youtube 영상입니다.(재생목록 링크: <a href="https://www.youtube.com/playlist?list=PL_BfGouHAX3AEQN553RetX2NK8OUp8fM-" target="_blank" rel="noopener">Youtube 재생목록 링크</a>).
        <div style={{ width: '100%', textAlign: 'center', display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <iframe
            width="100%"
            height="315"
            src="https://www.youtube.com/embed/u0IbpA6pyf4?si=G-FD6uXJuQyN_ObI"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ borderRadius: '8px', maxWidth: '560px', margin: '0 auto' }}
          />
          <iframe
            width="100%"
            height="315"
            src="https://www.youtube.com/embed/yi-bJlK897g?si=RRZ0GDoG7W-CZRmH"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ borderRadius: '8px', maxWidth: '560px', margin: '0 auto' }}
          />
        </div>
      </p>
    </div>
  );
};

export default MakeCodeArcadeTraining;